export const ActionTypes = {
  SET_ACTIVE_TYPE: 'zola/card/card_project/SET_ACTIVE_TYPE',
  SET_ACTIVE_VIEW: 'zola/card/card_project/SET_ACTIVE_VIEW',
};

export const setActiveType = activeType => {
  return {
    type: ActionTypes.SET_ACTIVE_TYPE,
    payload: activeType,
  };
};

export const setActiveView = activeView => {
  return {
    type: ActionTypes.SET_ACTIVE_VIEW,
    payload: activeView,
  };
};
